import "./ProductComponent.scss";
import React, { Fragment, useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import { useProduct } from "../hooks/useProduct";
import useMeasure from "use-measure";
import { animated, useSpring } from "react-spring";
import DOMPurify from "dompurify";
import marked from "marked";
import { FaMinus, FaPlus } from "react-icons/fa";
import SizeChart from "./SizeChart.jsx";
import Magnifier from "react-magnifier";
import config from '../config'

const sizesOrder = [
  'xxxs',
  'xxs',
  'xs',
  's',
  'm',
  'l',
  'xl',
  'xxl',
  '2xl',
  '3xl',
  '4xl'
]

const Divider = () => {
  return <div className="divider"></div>;
};
const TabBar = ({ open, first, title, body, onClick, children }) => {
  const ref = useRef();
  const { height } = useMeasure(ref);
  const animProps = useSpring({ height: height * 1.1 });

  const bodyCleaned = body ? DOMPurify.sanitize(body) : null;
  const bodyCleanedHtml = body ? marked(bodyCleaned) : null;

  return (
    <Fragment>
      <h3
        className={`tab ${open && "active"} ${first && "first"}`}
        data-tab-name="description"
        onClick={onClick}
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {title}
        {open && <FaMinus onClick={onClick} />}
        {!open && <FaPlus onClick={onClick} />}
      </h3>
      <animated.div
        style={{
          ...animProps,
          overflow: "hidden",
        }}
        id="product-description"
        className="product-details-content"
        data-tab-name="description"
        itemProp="description"
      >
        <div ref={ref}>
          {body ? (
            <div
              dangerouslySetInnerHTML={{ __html: bodyCleanedHtml }}
              style={{
                height: open ? "auto" : 0,
              }}
            />
          ) : (
            <div
              style={{
                height: open ? "auto" : 0,
              }}
            >
              {children}
            </div>
          )}
        </div>
      </animated.div>
    </Fragment>
  );
};

const ExpansionPanel = ({ ...product }) => {
  const [open, setOpen] = useState(0);

  const handleClick = (index) => () => {
    setOpen((state) => (state === index ? -1 : index));
  };

  return (
    <div className="tab-container">
      <TabBar
        body={product.body_html}
        title="Product Description"
        onClick={handleClick(0)}
        first
        open={open === 0}
      />
    </div>
  );
};

const ProductComponent = ({ producthandle, sectionid }) => {
  /* If we dont have a product id, we return */
  if (!producthandle) {
    return null;
  }

  /* Get product from API */
  const { product, isLoading } = useProduct(producthandle);

  /* Keep track of selected colour */
  const [selectedColor, setSelectedColor] = useState(null);

  /* Keep track of selected size for the selected colour */
  const [selectedSize, setSelectedSize] = useState(null);

  /* Effect triggered when we have a product */
  useEffect(() => {
    if (product && product.products.length > 0) {
      /* Try to find the hero variant if it exists */
      const heroColour = product.products.find(p => p.is_hero_variant === true)
      if (heroColour) {
        setSelectedColor(heroColour);
      }
      else {
        /* Set the first variant as the selected one */
        setSelectedColor(product.products[0]);
      }
    }
  }, [product, isLoading]);

  /* Effect triggered when we have a new selected color */
  useEffect(() => {
    /* Because the button is being rerendered / inserted as a new DOM node we need to reinit the Ajax cart */
    try {
      Shopify.AjaxifyCart && Shopify.AjaxifyCart.init();
    } catch (e) {
      console.error(e.message);
    }
  }, [selectedColor, selectedSize]);


  /* When a new color is selected, if a size is already selected, we need to select the right variant ID for that COLOR as the size atm is for another color */
  useEffect(() => {

    if (selectedColor && selectedSize) {
      // select the same size for that new color 
      const equivalentSize = selectedColor.variants.find(v => v.option1 === selectedSize.option1)
      setSelectedSize(equivalentSize)
    }
  }, [selectedColor])


  if (isLoading || !product || !selectedColor) {

    return (
      <div>
        <p>Loading....</p>
      </div>
    );
  }

  /* Compute all sizes available so the user can select the one they are interested in */
  const availableSizes = selectedColor.variants.filter(v => v.inventory_quantity > 0).reduce((result, variant) => {
    result[variant.option1] = variant;
    return result;
  }, {});

  /* Compute images for the selected color */
  const colorImages = selectedColor?.images;

  console.warn({ selectedColor })
  return (
    <div className="product-section">
      <div className="product-images">
        <ProductImages images={colorImages} />
      </div>
      <div className="product-info">
        <h1>{selectedColor.groupTitle.replace('&reg;', String.fromCodePoint(0x000AE))}</h1>
        <p>{`Color: ${selectedColor.colorName}`}</p>
        <div style={{
          display: 'flex',
          flexDirection: 'row',
        }}>
          <h3 className="price" style={{
            textDecoration: selectedColor.compareDisplayPrice > 0 ? 'line-through' : 'none',
          }}>{`$${parseFloat(
            selectedColor.compareDisplayPrice > 0 ? selectedColor.compareDisplayPrice : selectedColor.displayPrice
          ).toFixed(2)}`} </h3>
          {selectedColor.compareDisplayPrice > 0 && <h3 style={{ paddingLeft: 20, color: 'red' }} className="price">{`$${parseFloat(
            selectedColor.displayPrice
          ).toFixed(2)}`} </h3>}
        </div>
        <Divider />
        <div className="product-buy-section">
          <h4>COLOUR</h4>
          <div className="select-color">
            {product.products.sort((p1) => p1.is_hero_variant === true ? -1 : 1).map((color) => {
              return (
                <div
                  key={color.handle}
                  className="color-swatch"
                  style={{
                    backgroundImage: `url(${color.swatchUrl})`,
                  }}
                  onClick={() => setSelectedColor(color)}
                >
                  {/* <object data={backupImage} type="image/png">
                    <img src={`https://tommybahama.scene7.com/is/image/TommyBahama/${imageID}_sw?$main_plp_swatch$`} />
                  </object> */}
                </div>
              )
            })}
          </div>
          <h4 style={{ marginTop: 20 }}>SIZE</h4>
          <form
            method="post"
            action="/cart/add"
            encType="multipart/form-data"
            acceptCharset="UTF-8"
            id={`AddToCartForm-${sectionid}`}
            onSubmit={(e) => {
              e.preventDefault();

              theme.cart
                .addItemFromForm({ id: selectedSize.shopify_id })
                .then(() => {
                  $("body").trigger("added.ajaxProduct");
                });

              return false;
            }}
          >
            <input type="hidden" name="utf8" value="✓"></input>
            <input type="hidden" name="form_type" value="product"></input>
            <div className="product-form">
              {Object.keys(availableSizes).length > 0 && (
                <select
                  className="select-size-input"
                  name="id"
                  value={selectedSize?.shopify_id}
                  onChange={(e) => {
                    /* the event contains the ID of the color the user has chosen */
                    const selected_id = e.target.value;

                    if (selected_id) {
                      /* Get the size matching that id */
                      const selectedSize = Object.keys(availableSizes).find(
                        (size) => availableSizes[size].shopify_id === selected_id
                      );
                      setSelectedSize(availableSizes[selectedSize]);
                    } else {
                      setSelectedSize(null);
                    }
                  }}
                  required
                >
                  <option value={null}>Select Size</option>

                  {Object.keys(availableSizes).sort((a, b) => {
                    if (parseFloat(a) && parseFloat(b)) {
                      return parseFloat(a) - parseFloat(b)
                    }

                    if (sizesOrder.indexOf(a.toLowerCase()) < sizesOrder.indexOf(b.toLowerCase())) {
                      return -1
                    }

                    return 1
                  }).map((size) => {
                    /* Get the shopify id of that size */
                    const id = availableSizes[size].shopify_id;

                    /* Display option */
                    return (
                      <option
                        value={id}
                      >
                        {size}
                      </option>
                    );
                  })}
                </select>
              )}

              <div className="product-form-add-to-cart">
                <button
                  type="submit"
                  disabled={
                    !selectedSize ||
                    selectedSize.inventory_quantity === 0 || Object.keys(availableSizes).length === 0
                  }
                  name="add"
                  id="AddToCart"
                  aria-controls="CartDrawer"
                  className="btn--tertiary btn  btn--full btn--no-animate add-to-cart js-drawer-open-cart"
                >
                  <span id="AddToCartText">
                    {!selectedSize && Object.keys(availableSizes).length > 0 ? "SELECT SIZE" : ""}
                    {selectedSize && Object.keys(availableSizes).length > 0 ? "ADD TO CART" : ""}
                    {!selectedSize && Object.keys(availableSizes).length === 0 ? 'COMING SOON' : ""}
                  </span>
                </button>

                <SizeChart />
              </div>
            </div>
          </form>
        </div>
        <div className="product-details">
          <ExpansionPanel {...selectedColor} />
        </div>
      </div>
    </div>
  );
};

const ProductImages = ({ images }) => {
  /* Store the slide ref */
  const slideRef = useRef(null);

  /* Keep track of the selected image */
  const [selectedImage, setSelectedImage] = useState(images[0]);

  /* Method to handle click on an image */
  const handleOnImageClick = (image, index) => {
    /* Update state with selected image */
    setSelectedImage(image);

    /* Slide to image */
    slideRef && slideRef.current && slideRef.current.slickGoTo(index);
  };

  /* Configure slide show */
  const slideShowSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div data-product-images data-zoom="true" data-has-slideshow="true">
      <div className="product__photos product__photos product__photos--beside">
        <div
          className="product__main-photos"
          data-aos
          data-product-single-media-group
        >
          <Slider id="ProductPhotos" {...slideShowSettings} ref={slideRef}>
            {images.map((image, index) => (
              <ProductImage key={image.src} image={image} index={index} />
            ))}
          </Slider>
          <div className="product__photo-dots product__photo-dots-"></div>
        </div>

        <div
          id="ProductThumbs"
          className={`product__thumbs product__thumbs--beside ${images.length === 1 ? "hide" : ""
            }`}
          data-position="beside"
          data-arrows="true"
          data-aos
        >
          {images.map((img, index) => (
            <div
              key={img.src}
              className={`product__thumb-item ${img.src === selectedImage.src ? "selected" : ""
                }`}
              data-index="0"
            >
              <div className="image-wrap">
                <div
                  onClick={() => handleOnImageClick(img, index)}
                  className="product__thumb product__thumb js-no-transition"
                  data-index="0"
                  data-id={img.src}
                >
                  <img
                    className="animation-delay-3 lazyload"
                    data-src={img.src}
                    data-widths="[360, 540, 720, 900, 1080]"
                    data-aspectratio="1"
                    data-sizes="auto"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const ProductImage = ({ image, index }) => {
  return (
    <div key={image.src} data-index={index}>
      {
        image && window.innerWidth <= 768 && (
          <img
            className="lazyload"
            data-photoswipe-src={image.src}
            data-photoswipe-width="{{ media_width }}"
            data-photoswipe-height="{{ media_height }}"
            data-index={index}
            data-src={image.src}
            data-widths="[360, 540, 720, 900, 1080]"
            data-aspectratio="1"
            data-sizes="auto"
          />
        )
      }
      {
        image && window.innerWidth > 768 &&
        <Magnifier
          id="zoom1"
          className="lazyautosizes lazyloaded"
          src={image.src}
          mgWidth={300}
          mgHeight={300}
          enlargedImageContainerStyle={{ zIndex: 10000 }}
          zoomFactor={0.70}
        />
      }

    </div>
  );
};

export default ProductComponent;
